import React from "react";
import { BookOpenIcon, BrainIcon, LayersIcon, PuzzleIcon, ScanSearchIcon, TimerIcon, BoxIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { pains, PainKey } from "../../data/content";
const icons: Record<PainKey, BoxIcon> = {
  overwhelm: LayersIcon,
  time: TimerIcon,
  puzzle: PuzzleIcon,
  passive: BookOpenIcon,
  search: ScanSearchIcon,
  brain: BrainIcon
};
export function Pains() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-286" data-mp="31607c9frcalq">
      <div className="mx-auto max-w-5xl" data-id="element-287" data-mp="2w8hwuem3dnbm">
        <h2 className="text-balance text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-288" data-mp="2w7gmkccwh4uy">
          Does this sound <em className="text-gold" data-id="element-289" data-mp="3az7e9yq5bynx">familiar?</em>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] leading-relaxed text-ink/70 sm:text-lg" data-id="element-290" data-mp="35zcjvl75wqy4">
          If you're a plastic surgeon or qualified aesthetic physician, you may recognize some of these situations.
        </p>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-291" data-mp="3fue8mfxizr06">
          {pains.map(p => {
          const Icon = icons[p.key];
          return <li key={p.key} className="flex gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_0_rgba(20,26,43,0.06)] sm:p-6" data-id="element-292" data-mp="n0ph4kv34gqb">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-alert/10 text-alert" data-id="element-293" data-mp="rzahckac70er">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-294" data-mp="x0q54k3wfl0u" />
                </span>
                <div data-id="element-295" data-mp="11xq8gn9d69o9">
                  <h3 className="text-[17px] font-bold leading-snug text-ink" data-id="element-296" data-mp="11wf8yzmybo2y">{p.title}</h3>
                  {p.body.map(b => <p key={b} className="mt-2 text-[15px] leading-relaxed text-ink/70" data-id="element-297" data-mp="15xqo2b878qww">
                      {b}
                    </p>)}
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center" data-id="element-298" data-mp="1frr2x4ta9ait">
          <p className="text-[17px] leading-relaxed text-ink/80 sm:text-lg" data-id="element-299" data-mp="1kqkhz1o7x9l3">And it shouldn't have to feel so disorganized.</p>
          <p className="font-serif text-2xl font-bold leading-snug text-navy sm:text-3xl" data-id="element-300" data-mp="1plpz7n6oe02u">
            The problem isn't necessarily a lack of knowledge. Sometimes the knowledge just isn't organized into a{" "}
            <em className="text-gold" data-id="element-301" data-mp="19prpxyfg690c">repeatable system.</em>
          </p>
          <p className="text-[17px] leading-relaxed text-ink/80 sm:text-lg" data-id="element-302" data-mp="19ruox7ykvch7">
            That's exactly why I created Mastopexy Surgical Blueprint™.
          </p>
        </div>

        <div className="mt-10" data-id="element-303" data-mp="1iov9f3ij0qfd">
          <CTAButton label="I want a structured mastopexy system" data-id="element-304" data-mp="1is9eijikrdqi" />
        </div>
      </div>
    </section>;
}